module.exports = __webpack_public_path__ + "media/images/restaurant/areas/kyushu-fab363ee6a806b5ac2f18cc2158f2bd9.png";